export default "__VITE_ASSET__C2QOs$f5__"